import { storeUrls } from '../data/siteData';

/* ── App Store + Google Play download badges ─────────────────────────────────
   Used in heroes, CTA banners, and the contact/download hub. Links open the
   live Klaro Money listings in a new tab.                                      */

function AppleLogo() {
  return (
    <svg className="store-badge-glyph" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.05 12.54c-.02-2.02 1.65-2.99 1.72-3.04-.94-1.37-2.4-1.56-2.92-1.58-1.24-.13-2.43.73-3.06.73-.63 0-1.61-.71-2.65-.69-1.36.02-2.62.79-3.32 2.01-1.42 2.46-.36 6.1 1.02 8.1.67.98 1.47 2.08 2.52 2.04 1.01-.04 1.39-.65 2.61-.65 1.22 0 1.56.65 2.63.63 1.09-.02 1.78-1 2.45-1.98.77-1.13 1.09-2.23 1.11-2.29-.02-.01-2.13-.82-2.15-3.25zM15.1 6.32c.56-.68.94-1.62.84-2.56-.81.03-1.79.54-2.37 1.21-.52.6-.97 1.56-.85 2.48.9.07 1.82-.46 2.38-1.13z"/>
    </svg>
  );
}

function PlayLogo() {
  return (
    <svg className="store-badge-glyph" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3.6 2.3c-.25.27-.4.68-.4 1.22v16.96c0 .54.15.95.4 1.22l.06.05L13.1 12.1v-.2L3.66 2.25l-.06.05z" fill="#00D2FF"/>
      <path d="M16.25 15.25 13.1 12.1v-.2l3.15-3.15.07.04 3.73 2.12c1.07.6 1.07 1.59 0 2.2l-3.73 2.12-.07.02z" fill="#FFCE00"/>
      <path d="M16.32 15.21 13.1 12 3.6 21.7c.35.37.93.42 1.59.05l11.13-6.54z" fill="#FF3D44"/>
      <path d="M16.32 8.79 5.19 2.25c-.66-.37-1.24-.32-1.59.05L13.1 12l3.22-3.21z" fill="#00F076"/>
    </svg>
  );
}

export default function StoreButtons({ className = '', size = 'lg' }) {
  return (
    <div className={`store-buttons ${className}`}>
      <a
        href={storeUrls.ios}
        target="_blank"
        rel="noopener noreferrer"
        className={`store-badge store-badge-${size}`}
        aria-label="Download Klaro Money on the App Store"
      >
        <AppleLogo />
        <span className="store-badge-text">
          <span className="store-badge-top">Download on the</span>
          <span className="store-badge-bottom">App Store</span>
        </span>
      </a>
      <a
        href={storeUrls.android}
        target="_blank"
        rel="noopener noreferrer"
        className={`store-badge store-badge-${size}`}
        aria-label="Get Klaro Money on Google Play"
      >
        <PlayLogo />
        <span className="store-badge-text">
          <span className="store-badge-top">Get it on</span>
          <span className="store-badge-bottom">Google Play</span>
        </span>
      </a>
    </div>
  );
}
